import React, { useEffect, useRef } from 'react'
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Services = ({setActiveServices}) => {

    const [refDivService, inViewServices] = useInView({ threshold: 0.6});
    
    useEffect(() => {
        if (inViewServices) {
          setActiveServices(true); // Activa el estado del navbar
        } else {
            setActiveServices(false); // Desactiva el estado cuando ya no está visible
        }
    }, [inViewServices, setActiveServices]);

      const divRefOne = useRef(null);
      const divRefTwo = useRef(null);
      const divRefThree = useRef(null);
      const divRefFour = useRef(null);
    
      const [refOne, inViewOne] = useInView({ threshold: 0.5, triggerOnce:true });
      const [refTwo, inViewTwo] = useInView({ threshold: 0.5, triggerOnce:true });
      const [refThree, inViewThree] = useInView({ threshold: 0.5, triggerOnce:true });
      const [refFour, inViewFour] = useInView({ threshold: 0.5, triggerOnce:true });

    

  return (

    <>
      <section ref={refDivService} className="page-section" id="services" style={{paddingTop: '100px'}}>
          <div className="container px-4 px-lg-5">
              <h2 className="text-center mt-0">A tu servicio</h2>
              <hr className="divider" />
              <div className="row gx-4 gx-lg-5">
                    <motion.div
                    ref={divRefOne}
                    className={`animate ${inViewOne ? 'show' : ''} col-lg-3 col-md-6 text-center`}
                    initial={{ opacity: 0, y: -100 }}
                    animate={inViewOne ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 1 }}>
                        <div className=""
                        ref={refOne}
                        >
                            <div className="mt-5">
                                <div className="mb-2"><i class="fas fa-globe fa-2x" /></div>
                                <h3 className="h4 mb-2">Creación de páginas web</h3>
                                <p className="text-muted text-justify mb-0">Ofrezco el desarrollo de páginas web profesionales y completamente responsivas, diseñadas para adaptarse perfectamente a cualquier dispositivo y brindar una experiencia de usuario óptima. Potencia la presencia de tu marca con un sitio web moderno y atractivo que destaque tu portafolio de productos y servicios de manera efectiva.</p>
                            </div>
                        </div>

                    </motion.div>

                    <motion.div
                    ref={divRefTwo}
                    className={`animate ${inViewTwo ? 'show' : ''} col-lg-3 col-md-6 text-center`}
                    initial={{ opacity: 0, y: -100 }}
                    animate={inViewTwo ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 1 }}
                    >

                        <div className=""
                        ref={refTwo}>
                            <div className="mt-5">
                                <div className="mb-2"><i class="fas fa-laptop-code fa-2x"></i></div>
                                <h3 className="h4 mb-2">Desarrollo de aplicaciones web</h3>
                                <p className="text-muted text-justify mb-0">Desarrollo aplicaciones web personalizadas que optimizan y simplifican tus tareas diarias, permitiéndote gestionar procesos de manera eficiente desde cualquier lugar. También materializo tus ideas y las llevo a la web, creando soluciones innovadoras adaptadas a tus necesidades.</p>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                    ref={divRefThree}
                    className={`animate ${inViewThree ? 'show' : ''} col-lg-3 col-md-6 text-center`}
                    initial={{ opacity: 0, y: -100 }}
                    animate={inViewThree ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 1 }}
                    >
                        <div className=""
                        ref={refThree}>
                            <div className="mt-5">
                                <div className="mb-2"><i class="fas fa-tasks fa-2x"></i></div>
                                <h3 className="h4 mb-2">Automatización y optimización</h3>
                                <p className="text-muted text-justify mb-0" text-justify>Implemento soluciones de automatización que mejoran la eficiencia de tus procesos repetitivos, como el envío de correos, recordatorios, procesamiento de archivos o gestión de datos. Simplifica y acelera tus tareas mediante sistemas automáticos que optimizan tu flujo de trabajo y aumentan tu productividad.</p>
                            </div>
                        </div>

                    </motion.div>

                    <motion.div
                    ref={divRefFour}
                    className={`animate ${inViewFour ? 'show' : ''} col-lg-3 col-md-6 text-center`}
                    initial={{ opacity: 0, y: -100 }}
                    animate={inViewFour ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 1 }}>
                        <div className=""
                        ref={refFour}>
                            <div className="mt-5">
                                <div className="mb-2"><i class="fas fa-chalkboard-teacher fa-2x" /> <i class="fas fa-file-excel fa-2x" /></div>
                                <h3 className="h4 mb-2">Asesorías en Programación, Excel Avanzado y macros</h3>
                                <p className="text-muted text-justify mb-0">Brindo asesoría personalizada para el desarrollo de tus proyectos web, así como la automatización y optimización de tareas en Excel mediante técnicas avanzadas y creación de macros. Potencia tu productividad con soluciones a tu medida.</p>
                            </div>
                        </div>
                    </motion.div>
              </div>
          </div>
      </section>
    
    </>

  )
}

export default Services